import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
`
export const Required = styled.span`
  font-weight: 400;
  display: block;
  font-size: 0.8rem;
  position: relative;
  top: -3px;
  margin-left: 10px;
  color: #bbb;
`
